import { NumericTextBox } from "@tql/ui-components-react/tql/inputs/beta";
import { memo } from "react";

import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { PAYMENT_CONSTRAINTS } from "../../../../utils/constants.ts";
import styles from "./lump-sum-payment-mobile.module.css";

type LumpSumPaymentMobileProps = {
	outstandingBalance: number;
	amount?: number;
	onAmountChange?: (amount: number) => void;
};

export const LumpSumPaymentMobile = memo<LumpSumPaymentMobileProps>(
	({
		outstandingBalance,
		amount = 0,
		onAmountChange,
	}: LumpSumPaymentMobileProps) => {
		return (
			<div className={styles.lumpSumPaymentMobile}>
				<div className={styles.outstandingBalanceRow}>
					<span className={styles.fieldLabel}>Outstanding Balance:</span>{" "}
					<span className={styles.fieldValue}>
						{formatCurrency(outstandingBalance)}
					</span>
				</div>
				<span
					className={styles.fieldLabel}
					id={"lump-sum-payment-mobile-label"}
				>
					Pay Lump Sum (USD)
					<span className={"required"}> *</span>
				</span>
				<div className={styles.amountInputWrapper}>
					<span className={styles.currencyPrefix}>$</span>
					<NumericTextBox
						aria-labelledby={"lump-sum-payment-mobile-label"}
						id={"lump-sum-payment-mobile-amount"}
						max={PAYMENT_CONSTRAINTS.MAX_AMOUNT}
						min={0}
						onChange={(e) => {
							// Always propagate (including clearing to 0) since value is controlled by amount
							const value = e.target.value;
							onAmountChange?.(value !== null && value < 0 ? 0 : (value ?? 0));
						}}
						placeholder={"5,000"}
						spinners={false}
						value={amount > 0 ? amount : null}
					/>
				</div>
			</div>
		);
	},
);

LumpSumPaymentMobile.displayName = "LumpSumPaymentMobile";
